import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card card-default" }
const _hoisted_3 = { class: "card-header feature-header" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md margin-bottom" }
const _hoisted_6 = { class: "col-md-auto margin-bottom" }
const _hoisted_7 = { class: "col-md-auto margin-bottom" }
const _hoisted_8 = {
  class: "row d-flex",
  style: { justifyContent: 'end' }
}
const _hoisted_9 = {
  key: 2,
  class: "input-group input-group-sm",
  style: { width: '350px', float: 'right' }
}
const _hoisted_10 = { class: "input-group-prepend" }
const _hoisted_11 = { class: "input-group-text" }
const _hoisted_12 = {
  key: 0,
  class: "col-auto btn-group margin-bottom",
  role: "group",
  "aria-label": "Basic example"
}
const _hoisted_13 = { class: "card-body card-body-custom-layout" }
const _hoisted_14 = { class: "card-body-grid" }
const _hoisted_15 = {
  class: "btn-group actions-row",
  role: "group",
  "aria-label": "Basic example"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  class: "modal fade",
  id: "financialyearModal",
  role: "dialog"
}
const _hoisted_19 = { class: "modal-dialog modal-lg" }
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = { class: "modal-header" }
const _hoisted_22 = { class: "modal-title" }
const _hoisted_23 = { class: "modal-body" }
const _hoisted_24 = { class: "form-row" }
const _hoisted_25 = { class: "col-md" }
const _hoisted_26 = { class: "form-row mt-4" }
const _hoisted_27 = { class: "col-md" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "col-md" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "form-row mt-4" }
const _hoisted_32 = { class: "col-md" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "col-md" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "modal-footer" }
const _hoisted_37 = {
  type: "submit",
  class: "btn btn-sm btn-outline-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTitleComponent = _resolveComponent("CardTitleComponent")!
  const _component_SearchComponent = _resolveComponent("SearchComponent")!
  const _component_SubscriptionCommonComponent = _resolveComponent("SubscriptionCommonComponent")!
  const _component_CompanyCommonComponent = _resolveComponent("CompanyCommonComponent")!
  const _component_VueSelect = _resolveComponent("VueSelect")!
  const _component_e_column = _resolveComponent("e-column")!
  const _component_e_columns = _resolveComponent("e-columns")!
  const _component_ejs_grid = _resolveComponent("ejs-grid")!
  const _component_ConfirmComponent = _resolveComponent("ConfirmComponent")!
  const _component_EjsDatePicker = _resolveComponent("EjsDatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_CardTitleComponent)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_SearchComponent, {
                modelValue: _ctx.searchText,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                onSearch: _ctx.onSearch,
                onClear: _ctx.clearSearch
              }, null, 8, ["modelValue", "onSearch", "onClear"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: _normalizeClass(!_ctx.isFortnox() ? 'col-md margin-bottom' : 'col-auto')
                }, [
                  (_ctx.isHost() && !_ctx.isFortnox())
                    ? (_openBlock(), _createBlock(_component_SubscriptionCommonComponent, {
                        key: 0,
                        onOnSubscription: _ctx.subscriptionChange
                      }, null, 8, ["onOnSubscription"]))
                    : _createCommentVNode("", true),
                  (_ctx.isFortnox())
                    ? (_openBlock(), _createBlock(_component_CompanyCommonComponent, {
                        key: 1,
                        onOnCompanyChange: _ctx.onCompanyChange
                      }, null, 8, ["onOnCompanyChange"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("company")), 1)
                        ]),
                        _createVNode(_component_VueSelect, {
                          id: "filter-by-company",
                          class: "form-select",
                          "default-value": 0,
                          "default-message": _ctx.$t('all'),
                          modelValue: _ctx.companyId,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyId) = $event)),
                          items: 
                          _ctx.companies.map((c) => ({ id: c.id, text: c.name }))
                        ,
                          "on-change": () => _ctx.dataStateChange(_ctx.initState())
                        }, null, 8, ["default-message", "modelValue", "items", "on-change"])
                      ]))
                ], 2),
                (!_ctx.isFortnox())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("a", {
                        class: "btn btn-outline-info btn-sm",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.open()))
                      }, [
                        _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.$t("addNew")), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_ejs_grid, {
              ref: "gridFinancialYear",
              dataSource: _ctx.data,
              allowPaging: true,
              autoFit: true,
              allowResizing: true,
              pageSettings: _ctx.pageSettings,
              locale: _ctx.locale,
              rowHeight: 38,
              height: "100%",
              allowSorting: true,
              searchSettings: _ctx.searchOptions,
              dataStateChange: _ctx.dataStateChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_e_columns, null, {
                  default: _withCtx(() => [
                    (_ctx.isFortnox())
                      ? (_openBlock(), _createBlock(_component_e_column, {
                          key: 0,
                          headerText: _ctx.$t('companyName'),
                          field: "companyName"
                        }, null, 8, ["headerText"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('id'),
                      field: "Id"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('fromDate'),
                      field: "FromDate",
                      type: "date",
                      format: "yyyy-MM-dd"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('toDate'),
                      field: "ToDate",
                      type: "date",
                      format: "yyyy-MM-dd"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('accountCharts'),
                      field: "AccountCharts"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('accountingMethod'),
                      field: "AccountingMethod"
                    }, null, 8, ["headerText"]),
                    (!_ctx.isFortnox())
                      ? (_openBlock(), _createBlock(_component_e_column, {
                          key: 1,
                          headerText: _ctx.$t('actions'),
                          width: "75",
                          textAlign: "Center",
                          template: 'actionTemplate'
                        }, {
                          actionTemplate: _withCtx(({ data }) => [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("a", {
                                href: "javascript:void(0)",
                                class: "ms-2 action-link action-edit",
                                title: "Edit",
                                onClick: ($event: any) => (_ctx.commandClick('Edit', data))
                              }, [...(_cache[13] || (_cache[13] = [
                                _createElementVNode("i", {
                                  class: "e-edit e-icons",
                                  style: {"font-size":"0.76em"}
                                }, null, -1)
                              ]))], 8, _hoisted_16),
                              _createElementVNode("a", {
                                href: "javascript:void(0)",
                                class: "ms-2 action-link action-delete",
                                title: "Delete",
                                onClick: ($event: any) => (_ctx.commandClick('Delete', data))
                              }, [...(_cache[14] || (_cache[14] = [
                                _createElementVNode("i", {
                                  class: "e-delete e-icons",
                                  style: {"font-size":"0.76em"}
                                }, null, -1)
                              ]))], 8, _hoisted_17)
                            ])
                          ]),
                          _: 1
                        }, 8, ["headerText"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["dataSource", "pageSettings", "locale", "searchSettings", "dataStateChange"])
          ]),
          _createVNode(_component_ConfirmComponent, {
            title: _ctx.confirmTitle,
            onYes: _cache[3] || (_cache[3] = ($event: any) => (_ctx.commandConfirm()))
          }, null, 8, ["title"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("h4", _hoisted_22, _toDisplayString(_ctx.$t("financialYear")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.close()))
            }, [...(_cache[15] || (_cache[15] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onUpsert && _ctx.onUpsert(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t("company")), 1),
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                  ]),
                  _createVNode(_component_VueSelect, {
                    id: "add-fin-year",
                    class: "form-select",
                    "default-value": 0,
                    "default-message": _ctx.$t('Select company'),
                    modelValue: _ctx.form.companyId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.companyId) = $event)),
                    items: _ctx.companies.map((c) => ({ id: c.id, text: c.name }))
                  }, null, 8, ["default-message", "modelValue", "items"])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("fromDate")), 1),
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _createVNode(_component_EjsDatePicker, {
                      ref: "datepicker_from_date",
                      required: "",
                      format: "yyyy-MM-dd",
                      modelValue: _ctx.form.fromDate,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.fromDate) = $event)),
                      "first-day-of-week": 1
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("toDate")) + " ", 1),
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _createVNode(_component_EjsDatePicker, {
                      ref: "datepicker_to_date",
                      required: "",
                      format: "yyyy-MM-dd",
                      modelValue: _ctx.form.toDate,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.toDate) = $event)),
                      "first-day-of-week": 1
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("accountCharts")) + " ", 1),
                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-danger" }, null, -1))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control input-sm rounded-0",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.accountCharts) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.form.accountCharts]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("accountingMethod")) + " ", 1),
                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-danger" }, null, -1))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control input-sm rounded-0",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.accountingMethod) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.form.accountingMethod]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-danger",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.close()))
              }, [
                _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-times me-1" }, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.$t("close")), 1)
              ]),
              _createElementVNode("button", _hoisted_37, [
                _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fas fa-save me-1" }, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.isUpdate ? _ctx.$t("update") : _ctx.$t("save")), 1)
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ], 64))
}